export const truncate = (text: string, maxLength: number): string => {
   if (!(text && text.length < maxLength)) {
      return text ? `${text.substr(0, maxLength - 3)}...` : "";
   }
   return text;
};
